import React from 'react';
import PropTypes from 'prop-types';
import {getClipPath, getTranslate} from 'utils/attribute-util';
import styles from './index.css';

export default class SvgImage extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    clipPathID: PropTypes.string,
    height: PropTypes.number,
    url: PropTypes.string,
    width: PropTypes.number,
    x: PropTypes.number,
    y: PropTypes.number,
  };

  static defaultProps = {
    className: '',
    clipPathID: '',
    height: 0,
    url: '',
    width: 0,
    x: 0,
    y: 0,
  };

  render() {
    const clipPath = getClipPath(this.props.clipPathID);
    const transform = getTranslate(this.props.x, this.props.y);
    return (
      <image
        className={this.props.className || styles.SvgImage}
        clipPath={clipPath}
        height={this.props.height}
        transform={transform}
        width={this.props.width}
        xlinkHref={this.props.url}
      />
    );
  }
}
